var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgECoolingSource = function SvgECoolingSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.99 283.98 318 283.98 318 295.97 37.99 295.97 38 408 26 408 26 164.03 38 164 37.99 283.98",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 164.03,
    width: 1,
    height: 243.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33 288.96 318 288.96 318 290.96 33 290.99 33 408 31 408 31 164 33 164 33 288.96",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "36 164.03 35 164 35.03 286.99 318 286.96 318 285.96 35.99 285.96 36 164.03",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35 292.96 317.99 292.96 317.99 293.96 36 293.96 36 408.01 35 408.01 35 292.96",
    fill: "#787878"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 408,
    width: 48,
    height: 72,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.39 439.2 22.85 437.68 22 438.01 22.16 438.94 24.68 440.45 22.67 441.66 22.51 442.61 23.37 442.92 26.09 441.29 30.59 444 26.09 446.71 23.37 445.08 22.51 445.39 22.67 446.34 24.68 447.54 22.16 449.06 22 449.99 22.85 450.32 25.39 448.8 25.39 451.22 26.09 451.83 26.79 451.22 26.79 447.97 31.3 445.26 31.3 450.67 28.58 452.3 28.42 453.23 29.28 453.56 31.3 452.35 31.3 455.39 32 456 32.69 455.39 32.69 452.35 34.72 453.56 35.56 453.23 35.4 452.3 32.69 450.67 32.69 445.26 37.21 447.97 37.21 451.22 37.91 451.83 38.6 451.22 38.6 448.8 41.14 450.32 42 449.99 41.84 449.06 39.3 447.54 41.31 446.34 41.47 445.39 40.61 445.08 37.91 446.71 33.39 444 37.91 441.29 40.61 442.92 41.47 442.61 41.31 441.66 39.3 440.45 41.84 438.94 42 438.01 41.14 437.68 38.6 439.2 38.6 436.78 37.91 436.17 37.21 436.78 37.21 440.03 32.69 442.74 32.69 437.33 35.4 435.7 35.56 434.77 34.72 434.44 32.69 435.65 32.69 432.61 32 432 31.3 432.61 31.3 435.65 29.28 434.44 28.42 434.77 28.58 435.7 31.3 437.33 31.3 442.74 26.79 440.03 26.79 436.78 26.09 436.17 25.39 436.78 25.39 439.2",
    fill: "#fff"
  })))));
};
export default SvgECoolingSource;